<template>
  <div
    v-if="context"
    class="tw-relative tw-z-0 'tw-flex tw-flex-col tw-h-full"
    data-walkthrough-id="workflow-review-communication"
    data-behaviour="workflow-review-sidepane"
    data-testid="sidepane-container"
    :data-context-id="context.id"
    :data-context-type="context.itemClass"
    @click.stop="clearHighlightedCard"
  >
    <sidepane-communication
      empty-translation-key="communication.workflow_review_empty_state"
      :is-body-scrollable="false"
      :show-empty-state-image="false"
      :show-timeline="false"
    />
  </div>
</template>

<script>
import { mapActions as mapPiniaActions, mapState as mapPiniaState } from 'pinia'
import { mapActions, mapState } from 'vuex'
import SidepaneCommunication from '@app/application/communication/sections/communication/components/sidepane-communication'
import registerSidepanePageVisitMixin from '@app/shared/vue/mixins/register-sidepane-page-visit'

import { useWorfklowReviewItems } from '../store/pinia/workflow-review-items'
import { useDrawer } from '@app/shared/pinia/drawer'

export default {
  name: 'WorkflowReviewSidepane',
  components: {
    SidepaneCommunication,
  },
  mixins: [registerSidepanePageVisitMixin],
  props: {
    ledgerId: {
      type: [String, Number],
      required: true,
    },
    ledgerLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['clearAnchor'],
  computed: {
    ...mapState({
      highlightedCard: (state) => state.ui.highlightedCard,
      fetchingCommunicationsStatus: (state) =>
        state.ui.fetchingCommunicationsStatus,
    }),
    ...mapPiniaState(useWorfklowReviewItems, {
      context: 'currentReviewItem',
    }),
    ...mapPiniaState(useDrawer, ['isRightDrawerOpen']),
    // needed for the registerSidepanePageVisit mixin
    contextType() {
      return this.context?.itemClass
    },
    contextId() {
      return this.context?.id
    },
  },
  created() {
    window.eventHub.$on('openSidepane', this.effectiveOpenDrawer)
  },
  beforeUnmount() {
    window.eventHub.$off('openSidepane', this.effectiveOpenDrawer)
  },
  methods: {
    ...mapActions(['unsetHighlightedCard']),
    ...mapPiniaActions(useDrawer, ['openRightDrawer', 'closeDrawer']),
    clearHighlightedCard() {
      if (this.highlightedCard.id) {
        this.unsetHighlightedCard()
        window.eventHub.$emit('clearAnchor')
      }
    },
    close() {
      this.closeDrawer()
    },
    effectiveOpenDrawer() {
      this.openRightDrawer('communication')
    },
  },
}
</script>
